import type { Story } from '../../types/models';

interface FeaturedStoryHeroProps {
  story: Story;
  className?: string;
}

export function FeaturedStoryHero({ story, className = '' }: FeaturedStoryHeroProps) {
  return (
    <div
      className={`card flex flex-col justify-end gap-3 min-h-[220px] bg-cover bg-center ${className}`}
      style={
        story.coverImageUrl
          ? {
              backgroundImage: `linear-gradient(0deg, rgba(10,10,10,0.85), rgba(10,10,10,0.2)), url(${story.coverImageUrl})`,
            }
          : undefined
      }
    >
      <h3 className="text-xl font-semibold leading-snug">{story.title}</h3>
      <p className="text-sm text-neutral-300 line-clamp-2">{story.excerpt}</p>
    </div>
  );
}

interface StoryTileProps {
  story: Story;
  className?: string;
}

export function StoryTile({ story, className = '' }: StoryTileProps) {
  return (
    <div className={`card flex flex-col gap-2 ${className}`}>
      <div className="text-xs uppercase text-neutral-400">Guide</div>
      <div className="font-semibold leading-snug">{story.title}</div>
    </div>
  );
}
